import {
  ApplicationConfig,
  APP_INITIALIZER,
  provideBrowserGlobalErrorListeners
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { keycloakBearerInterceptor } from './core/auth/keycloak-bearer.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const PreisradarPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: '#1282ac',
          contrastColor: '#ffffff',
          hoverColor: '#0f6a8e',
          activeColor: '#0c5472'
        }
      },
      dark: {
        primary: {
          color: '#1282ac',
          contrastColor: '#ffffff',
          hoverColor: '#0f6a8e',
          activeColor: '#0c5472'
        }
      }
    }
  }
});

function initializeKeycloak(keycloak: KeycloakService) {
  return () => {
    const referrer = sessionStorage.getItem('preisradar_initial_referrer') ?? '';
    const keycloakUrl = environment.production && referrer.startsWith('https://quimus.ebuch.de')
      ? 'https://quimus.ebuch.de/auth/'
      : environment.keycloak.url;

    return keycloak.init({
      config: {
        url: keycloakUrl,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
      },
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256'
      },
      bearerExcludedUrls: []
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([keycloakBearerInterceptor])),
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },
    providePrimeNG({
      theme: {
        preset: PreisradarPreset,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-mode',
          cssLayer: false
        }
      }
    })
  ]
};
